module.exports = __webpack_public_path__ + "static/media/neural.412ef654.jpg";